import { useEffect, useState } from 'react';
import { apiJson } from '../api/client.js';
import { MailboxMeetingsList } from '../components/MailboxPanels.jsx';

export function AdminMeetingsPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiJson('/api/admin/meetings')
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h2 style={{ marginTop: 0 }} data-tour="page-title">Video calls & meetings</h2>
      <p className="muted small">
        Upcoming Teams / Outlook events from your calendar{data?.mailbox ? ` (${data.mailbox})` : ''}.
      </p>
      {error ? <p className="err">{error}</p> : null}
      <MailboxMeetingsList data={data} loading={loading} />
    </div>
  );
}
